import { Reveal, Kicker } from "./Reveal";

const STATE = [
  ["Platform prototype live", "Existing pricing, governance and platform capability already exists."],
  ["Governed V1 programme", "The current delivery phase is concentrating the platform around Decision → Policy → Ledger → Execution → Outcome."],
  ["Design-partner programme", "Three 90-day pilots are the immediate commercial objective."],
  ["Seed round", "Axiosera is preparing a £2.5M seed to fund the transition from technology to repeatable commercial evidence."],
];

export default function Position() {
  return (
    <section id="position" className="border-b border-white/10 bg-[#0A0A0B]" data-testid="position-section">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <Reveal>
          <Kicker index="09" label="Current position" />
          <h2 className="max-w-5xl font-display text-4xl font-extrabold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl" data-testid="position-heading">
            From platform prototype to <span className="text-[#00FF41]">commercial proof.</span>
          </h2>
        </Reveal>

        <div className="mt-20 grid gap-px border border-white/10 bg-white/10 md:grid-cols-2">
          {STATE.map(([title, desc], i) => (
            <Reveal key={title} delay={i * 0.08} className="bg-[#0A0A0B] p-10 transition-colors duration-500 hover:bg-[#0F0F11]">
              <div className="font-mono text-xs text-[#00FF41]">0{i + 1}</div>
              <h3 className="mt-6 font-display text-xl font-bold tracking-tight" data-testid={`position-state-${i + 1}`}>{title}</h3>
              <p className="mt-4 font-mono text-xs leading-relaxed text-zinc-500">{desc}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-12 max-w-3xl font-mono text-sm leading-relaxed text-zinc-400" data-testid="position-closing">
            The round is primarily funding proof, customers, security, decision science and company
            capability — <span className="text-white">not a greenfield software build.</span>
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-16">
          <div className="grid border border-white/10 lg:grid-cols-12" data-testid="team-block">
            <div className="relative overflow-hidden lg:col-span-4">
              <img
                src="/founder.png"
                alt="Steve Burke, Founder"
                className="h-72 w-full object-cover object-top grayscale transition-all duration-700 hover:grayscale-0 lg:h-full"
              />
              <div className="scanlines absolute inset-0" />
            </div>
            <div className="p-10 lg:col-span-8 lg:p-14">
              <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">Founder</div>
              <h3 className="mt-6 font-display text-3xl font-extrabold tracking-tighter">Steve Burke</h3>
              <p className="mt-6 max-w-2xl font-mono text-xs leading-relaxed text-zinc-400">
                Years running governance, control frameworks and delivery assurance for large-scale
                public-sector engineering programmes. Knowing what it takes for a large organisation to
                trust a system with consequential decisions — because building that trust has been the job.
              </p>
              <div className="mt-8 font-mono text-xs text-zinc-500">
                <span className="mr-2 inline-block h-1.5 w-1.5 rounded-full bg-[#00FF41] glow-dot" />
                Platform prototype live on staging — policy enforcement returning 412s on bound breaches.
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
